import {
    IonItem,
    IonIcon,
    IonButton,
    useIonActionSheet,
    IonNote,
} from '@ionic/react';
import { getMode } from '@ionic/core';
import {
    ellipsisHorizontalSharp,
    ellipsisVerticalSharp,
    trash,
    pencil,
    close,
    caretDown,
    caretUp,
 } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { colorTheme } from '../../utils/constants';

const TeamListItem = ({firstName, lastName, personId, phoneNumber, username, email, showDetails, teamMember, handleTeamMemberAction}) => {
    const [showExtraDetails, setShowExtraDetails] = useState(false);
    useEffect(() => {
        setShowExtraDetails(showDetails);
    }, [showDetails])

    const [present] = useIonActionSheet();
    const [extraData, setExtraData] = useState([
        {label: 'Name', value: firstName + " " + lastName},
        {label: 'Phone Number', value: phoneNumber},
        {label: 'Email', value: email},
        {label: 'Username', value: username},
    ]);

    const open = async () => {
        const mode = getMode();
        const buttons = [{
          text:  'Edit',
          role: 'destructive',
          icon: mode !== 'ios' ? pencil : '',
          handler: () => {
              handleTeamMemberAction('edit', personId);
          }
        },
        {
          text: 'Delete',
          icon: mode !== 'ios' ? trash : '',
          handler: () => {
            handleTeamMemberAction('delete', personId);
          }
        }, {
          text: 'Cancel',
          role: 'cancel',
          icon: mode !== 'ios' ? close : '',
          handler: () => {}
        }];

        present({
          header: firstName + "  " + lastName,
          buttons: buttons
        });
    }

    return (
        <IonItem lines="none" key={personId}>
            <Row style={{width: '100%'}} className='my-2 mx-0 shadow-sm rounded'>
            <Row className='rounded'
            >
                <Col onClick={ () => { setShowExtraDetails(!showExtraDetails)} } xs={6} md={5}>
                    <strong>{username}&nbsp;
                    <IonIcon
                        style={{fontSize: '20px', marginRight: '10px', color: 'var(--ion-color-primary)' }}
                        icon={!showExtraDetails ? caretDown : caretUp}
                    ></IonIcon></strong>
                </Col>

                <Col xs={4} md={6}>
                    <IonNote className='text-sm md:text-base'>{email.length > 16 ? `${email.slice(0, 12)}...` : email}</IonNote>
                </Col>

                <Col xs={1} md={1} className='my-0 py-0 d-block d-md-none'>
                <IonButton onClick={open} fill="clear" className=''>
                    <IonIcon size="large" aria-hidden="true"  ios={ellipsisHorizontalSharp} md={ellipsisVerticalSharp} style={{ color: 'var(--ion-color-primary)' }} />
                </IonButton>
                </Col>
                <Col xs={1} md={1} className='my-0 py-0 d-none d-md-block'>
                <IonButton onClick={open} fill="clear" className=''>
                    <IonIcon size="large" aria-hidden="true"  icon={ellipsisHorizontalSharp} style={{ color: 'var(--ion-color-primary)' }} />
                </IonButton>
                </Col>
            </Row>

                {showExtraDetails && (<Row style={{backgroundColor: colorTheme["primary"]["25"] }} className='mx-2 mr-3 mb-2 py-3 rounded tenant-list-row'>
                    <Row className="mb-2">
                        <IonButton onClick={() => handleTeamMemberAction("edit", personId)}>Edit Team Member</IonButton>
                    </Row>
                    <Row>
                        <IonButton 
                            fill="outline"
                            onClick={(e) => {
                                e.stopPropagation();
                                open();
                            }}
                        >
                            Options
                        </IonButton>
                    </Row>
                    { extraData.map((data, index) => (
                        <Row key={index} className='border-bottom my-1'>
                        <Col  xs={4} md={3}><strong>{data.label}</strong></Col>
                        <Col xs={8} md={8}>
                            <span style={{fontSize: '16px'}}>{data.value}</span>
                        </Col>
                        </Row>
                    ))}
                </Row>)}
            </Row>
    </IonItem>
    );

}
export default TeamListItem;